document.querySelectorAll(".swiper-collection").forEach(function (el) {
  new Swiper(el, {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 12,
    watchOverflow: true,

    breakpoints: {
      768: {
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },

    scrollbar: {
      el: el.querySelector(".custom-scrollbar"),
      hide: false,
      draggable: true,
    },
  });
});
